import BaseTourSectionPanel from "@components/tour_sections/BaseTourSectionPanel";

function BeforeYouGoPanel(props) {
  return <BaseTourSectionPanel {...props} panelTitle="Before you go" />;
}

export default BeforeYouGoPanel;
